import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: "48",
  width: "48",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M10.5,24A10.51,10.51,0,0,0,21,13.5a.5.5,0,0,0-.5-.5h-9a.5.5,0,0,1-.5-.5v-9a.5.5,0,0,0-.5-.5,10.5,10.5,0,0,0,0,21Z",
        fill: "currentColor"
      }),
      _createElementVNode("path", {
        d: "M13.5,0a.5.5,0,0,0-.5.5V10a1,1,0,0,0,1,1h9.5a.5.5,0,0,0,.5-.5A10.51,10.51,0,0,0,13.5,0Z",
        fill: "currentColor"
      })
    ], -1)
  ])))
}
export default { render: render }